<template>
  <b-container fluid>
    <backlink />
    <h1>Références en attente de maintenance</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="status" slot-scope="{ data }">
        <b-badge variant="primary">{{ data.value }}</b-badge>
      </template>
      <template slot="next_espected_maintenance_date" slot-scope="{ data }">
        <span class="text-red" v-if="data.item.retard > 0">{{ format_date(data.value) }}</span>
        <span class="text-orange" v-else-if="data.item.retard > -31">{{ format_date(data.value) }}</span>
        <span v-else>{{ format_date(data.value) }}</span>
      </template>
      <template slot="retard" slot-scope="{ data }">
        <span v-if="data.value > 0">{{ data.value }}</span>
        <span v-else></span>
      </template>
      <template slot="group_slug" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value.includes('outillage')" variant="outillage" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-if="data.value.includes('instruments')" variant="instruments" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-if="data.value.includes('service_et_logistique')" variant="service_et_logistique"
            class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "OverdueMaintenanceReferenceList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      let status_options = this.$store.getters["status/getByGroup"]("reference").selectOptions(
        "status_slug",
        "name"
      );
      return {
        status_options: [
          status_options[2],
          status_options[4],
          status_options[1],
          status_options[5],
          status_options[3],
        ],
        return_mode_options: this.$store.getters["product/getReturnModes"],
        filter_retard_options: [
        {
          value: 'passed',
          text: 'Date dépassée'
        },{
            value: 'this-month',
            text: 'A faire ce mois'
        }],
        agency_number_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
      };
    },
  },
  mounted() {
    this.$store.dispatch("agency/getAllForSelect");
  },
  methods: {
    format_date(value){
      if (value) {
        return this.$moment(String(value)).format('DD-MM-YYYY')
      }
    },
    itemsProvider(ctx) {
      var self = this;

      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "reference", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy != "penality" ? ctx.sortBy : "retard",
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              origin: "overDueMaintenanceReferenceList",
              agency: ctx.extended_filters_model.agency_number,
              user: ctx.extended_filters_model.user,
              statusSlug: ctx.extended_filters_model.status,
              group_slug: ctx.extended_filters_model.group_slug,
              retard: ctx.extended_filters_model.filter_retard,
              return_mode: ctx.extended_filters_model.return_mode,
              startNextEspectedMaintenanceDate: ctx.extended_filters_model
                .next_espected_maintenance_date.start
                ? self
                    .$moment(ctx.extended_filters_model.next_espected_maintenance_date.start)
                    .format("YYYY-MM-DD")
                : null,
              endNextEspectedMaintenanceDate: ctx.extended_filters_model
                .next_espected_maintenance_date.end
                ? self
                    .$moment(ctx.extended_filters_model.next_espected_maintenance_date.end)
                    .format("YYYY-MM-DD")
                : null,
              asker: ctx.extended_filters_model.asker,
            },

          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.references || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>
<style type="scss" scoped>
  .text-red{ color: red; }
  .text-orange{ color: orange; }
</style>



// WEBPACK FOOTER //
// src/components/OverdueMaintenanceReference/OverdueMaintenanceReferenceList.vue